module.exports = __webpack_public_path__ + "img/maestro.7128ce6.png";